import React from 'react';
import Loadable from 'react-loadable';
import { Redirect, Switch } from 'react-router-dom';
import EditableRoute from '@components/EditableRoute';
import MraPageWrapper from './components/PageWrapper';

const Loading = () => <div />;

const Models = Loadable({
  loader: () => import('./pages/models'),
  loading: Loading,
});

const Model = Loadable({
  loader: () => import('./pages/model'),
  loading: Loading,
});

export const MraRoute = {
  Models: '/mra/models',
  Model: '/mra/model/:modelId',
  Settings: '/mra/settings',
  View: '/mra/view/:analysisId/:type/:propertyId', //
};

export const MraPageTitle = {
  [MraRoute.Models]: 'Models',
  [MraRoute.Model]: 'Model',
  [MraRoute.Settings]: 'Settings',
};

const MraRoutes = props => (
  <MraPageWrapper {...props}>
    <Switch>
      <EditableRoute component={Models} exact path={MraRoute.Models} />
      <EditableRoute component={Model} exact path={MraRoute.Model} />
      <EditableRoute component={Model} exact path={MraRoute.View} />
      <EditableRoute component={() => <div />} exact path={MraRoute.Settings} />

      <Redirect to={MraRoute.Models} />
    </Switch>
  </MraPageWrapper>
);

export default MraRoutes;
